export const TEXT       = 'TEXT';
export const VIDEO      = 'VIDEO';
export const IMAGE      = 'IMAGE';
export const HEADLINE   = 'HEADLINE';